module.exports = __webpack_public_path__ + "static/TT-Plans-Outdoor_Spaces-8a0aa64f8296cf8cda06ae23ae4c8a9b.jpg";